/**
 * Customer buying journey: funnel stages A–K (one letter per step). Use for Clarity and DB.
 */

export const ALLOW_LOCALHOST_FOR_JOURNEY_TESTING = false

export const LANDING_VISITED_KEY = 'digipalz_landing_visited'

export const JOURNEY_FUNNEL_STAGES = {
  A_LANDING: 'a_landing',
  B_PRICING: 'b_pricing',
  C_SIGNUP: 'c_signup',
  D_VERIFICATION: 'd_verification',
  E_ONBOARDING: 'e_onboarding',
  F_PRICING: 'f_pricing',
  G_CHECKOUT: 'g_checkout',
  H_ACTIVATION: 'h_activation',
  I_CHILD_ONBOARDING: 'i_child_onboarding',
  J_RETENTION: 'j_retention',
  K_CHURN: 'k_churn'
}

export const JOURNEY_FUNNEL_EVENTS = {
  LANDING_VIEW: 'journey_landing_view',
  CONTENT_ENGAGEMENT: 'journey_content_engagement',
  PRICING_VIEW: 'journey_pricing_view',
  PLAN_PAGE_VIEW: 'journey_pricing_view',
  PLAN_SELECTED: 'journey_plan_selected',
  TRIAL_STARTED: 'journey_trial_started',
  SIGNUP_START: 'journey_signup_started',
  SIGNUP_COMPLETE: 'journey_signup_submitted',
  VERIFICATION_NOTE_VIEW: 'journey_email_verify_started',
  VERIFY_COMPLETE: 'journey_email_verify_completed',
  PARENT_ONBOARDED: 'activation_onboarding_step_completed',
  CHILD_ONBOARDED: 'journey_child_onboarded',
  CHECKOUT_REDIRECT: 'journey_checkout_started',
  PAYMENT_SUCCESS: 'journey_purchase_completed',
  PAYMENT_CANCEL: 'journey_checkout_payment_failed',
  ACTIVATION_FIRST_MISSION_STARTED: 'activation_first_mission_started',
  ACTIVATION_AHA: 'activation_first_mission_completed',
  FIRST_MISSION_COMPLETE: 'activation_first_mission_completed',
  MISSION_COMPLETE: 'activation_mission_completed',
  RETURN_SESSION: 'retention_returned_day_1',
  RETENTION_RETURNED_DAY_1: 'retention_returned_day_1',
  RETENTION_RETURNED_DAY_7: 'retention_returned_day_7',
  CHURN_INTENT_VIEW: 'churn_cancel_intent_viewed',
  CANCEL_CLICK: 'churn_cancel_confirmed',
  DOWNGRADE_VIEW: 'churn_downgrade_viewed',
  CTA_CLICK: 'journey_cta_click',
  SUBSCRIPTION_STATUS_UPDATED: 'journey_subscription_status_updated',
  SUBSCRIPTION_STATUS_CHANGED: 'journey_subscription_status_changed',
  SUBSCRIPTION_CANCELLED: 'journey_subscription_cancelled',
  SUBSCRIPTION_CREATED: 'journey_subscription_created',
  RECURRING_PAYMENT_SUCCEEDED: 'journey_recurring_payment_succeeded',
  PAYMENT_FAILED: 'journey_payment_failed'
}

export const BUYING_JOURNEY_STAGES = {
  PLAN_VIEW: 'plan_view',
  PLAN_SELECT: 'plan_select',
  CHECKOUT_START: 'checkout_start',
  CHECKOUT_COMPLETE: 'checkout_complete',
  CHECKOUT_CANCEL: 'checkout_cancel'
}

export const BUYING_JOURNEY_EVENTS = {
  PLAN_PAGE_VIEW: 'plan_page_view',
  PLAN_SELECTED: 'plan_selected',
  CHECKOUT_REDIRECT: 'checkout_redirect',
  PAYMENT_SUCCESS: 'payment_success',
  PAYMENT_CANCEL: 'payment_cancel'
}

export const JOURNEY_USER_TYPES = {
  PARENT: 'parent',
  SCHOOL: 'school',
  EDUCATOR: 'educator'
}
